import StoredLayout from '../../layouts/StoredLayout'
import WeatherIcons from './WeatherIcons'
export default StoredLayout(WeatherIcons)



// WEBPACK FOOTER //
// ./src/icons/weather-icons/index.js